import { ParamsList } from '@gumtree/shared/src/partnerships/validator/shared';

export const filterByParamsList = (params: object, paramsList: ParamsList): object => {
    const requestedKeys = paramsList.map(({ keyName }) => keyName);
    return Object.entries(params)
        .filter(([key, _]) => requestedKeys.includes(key))
        .reduce((acc, [key, val]) => {
            acc[key] = val;
            return acc;
        }, {});
};

export const transformObjectToString = (params: object): string =>
    Object.entries(params)
        .filter(([_, value]) => Boolean(value))
        .map(([key, _]) => `${key}=${params[key]}`)
        .join('&');
